import { useEffect, useRef, useState } from 'react'
import { MfaState, RECAPTCHA_CONTAINER_ID } from '../hooks/useAuth'

interface LoginPageProps {
  onSignIn: () => void
  error: string | null
  mfa: MfaState | null
  onVerifyMfaCode: (code: string) => void
  onResendMfaCode: () => void
  onCancelMfa: () => void
}

export function LoginPage({
  onSignIn,
  error,
  mfa,
  onVerifyMfaCode,
  onResendMfaCode,
  onCancelMfa,
}: LoginPageProps) {
  const [code, setCode] = useState('')
  const autoSubmittedRef = useRef(false)

  // Limpa o código ao entrar/sair da etapa de MFA ou reenviar SMS
  useEffect(() => {
    setCode('')
    autoSubmittedRef.current = false
  }, [mfa?.phoneHint, mfa?.sending])

  useEffect(() => {
    if (mfa && code.length === 6 && !mfa.verifying && !autoSubmittedRef.current) {
      autoSubmittedRef.current = true
      onVerifyMfaCode(code)
    }
  }, [code, mfa, onVerifyMfaCode])

  const handleCodeChange = (value: string) => {
    autoSubmittedRef.current = false
    setCode(value.replace(/\D/g, '').slice(0, 6))
  }

  return (
    <div className="login-container">
      <div className="card login-card">
        <h1 style={{ marginBottom: 8 }}>Analytics Experiments</h1>

        {!mfa && (
          <>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 24 }}>
              Acesso restrito a contas @widde.io
            </p>
            <button className="btn btn-primary" onClick={onSignIn} style={{ width: '100%' }}>
              Entrar com Google
            </button>
          </>
        )}

        {mfa && (
          <>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 24 }}>
              {mfa.sending
                ? 'Enviando código por SMS...'
                : `Digite o código de 6 dígitos enviado por SMS para ${mfa.phoneHint || 'seu telefone'}`}
            </p>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              value={code}
              onChange={(e) => handleCodeChange(e.target.value)}
              disabled={mfa.sending || mfa.verifying}
              placeholder="000000"
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: 24,
                textAlign: 'center',
                letterSpacing: 8,
                border: '1px solid #d1d5db',
                borderRadius: 8,
                marginBottom: 12,
                boxSizing: 'border-box',
              }}
            />
            <button
              className="btn btn-primary"
              onClick={() => onVerifyMfaCode(code)}
              disabled={code.length !== 6 || mfa.sending || mfa.verifying}
              style={{ width: '100%', marginBottom: 12 }}
            >
              {mfa.verifying ? 'Verificando...' : 'Verificar'}
            </button>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
              <button
                onClick={onCancelMfa}
                style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', padding: 0 }}
              >
                Voltar
              </button>
              <button
                onClick={onResendMfaCode}
                disabled={mfa.sending || mfa.resendCooldown > 0}
                style={{
                  background: 'none',
                  border: 'none',
                  color: mfa.resendCooldown > 0 ? '#9ca3af' : '#2563eb',
                  cursor: mfa.resendCooldown > 0 ? 'default' : 'pointer',
                  padding: 0,
                }}
              >
                {mfa.resendCooldown > 0 ? `Reenviar em ${mfa.resendCooldown}s` : 'Reenviar código'}
              </button>
            </div>
          </>
        )}

        {error && <div className="login-error">{error}</div>}
        <div id={RECAPTCHA_CONTAINER_ID} />
      </div>
    </div>
  )
}
